import React from 'react';
import { Heart, MessageCircle, Send, Bookmark } from 'lucide-react';

const InstagramPreview = ({ post, layout = 'feed' }) => {
  if (layout === 'story') {
    return <InstagramStoryPreview post={post} />;
  }
  return <InstagramFeedPreview post={post} />;
};

// Instagram Story Preview Component
const InstagramStoryPreview = ({ post }) => (
  <div className='max-w-[350px] flex items-center justify-center'>
    <div
      className='relative bg-black rounded-lg overflow-hidden shadow-2xl'
      style={{ aspectRatio: '9/16' }}
    >
      {/* Story Image */}
      <img
        src={post.path || post.imageUrl}
        alt='Story Preview'
        className='w-full h-full object-cover'
      />

      {/* Top Bar */}
      <div className='absolute top-0 left-0 right-0 p-2 bg-gradient-to-b from-black/60 to-transparent'>
        {/* Progress Bar */}
        <div className='flex gap-1 mb-2'>
          <div className='flex-1 h-0.5 bg-white/30 rounded-full'>
            <div className='h-full w-1/2 bg-white rounded-full'></div>
          </div>
        </div>

        {/* Profile Info */}
        <div className='flex items-center gap-2'>
          <div className='w-8 h-8 rounded-full bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600 p-[2px]'>
            <div className='w-full h-full rounded-full bg-gray-800 flex items-center justify-center'>
              <span className='text-white text-xs font-semibold'>B</span>
            </div>
          </div>
          <span className='text-white text-sm font-semibold'>Your Business</span>
          <span className='text-white/70 text-xs'>now</span>
        </div>
      </div>

      {/* Bottom Actions */}
      <div className='absolute bottom-2 left-0 right-0 px-2'>
        <div className='flex items-center gap-1'>
          <input
            type='text'
            placeholder='Send message'
            className='flex-1 min-w-0 bg-transparent border border-white/50 rounded-full px-2 lg:px-4 py-1 lg:py-2 text-white text-xs lg:text-lg placeholder-white/70'
            readOnly
          />
          {/* Heart icon */}

          <Heart className='w-4 h-4 m-1 lg:w-7 lg:h-7 text-white' />

          {/* Send icon */}

          <Send className='w-4 h-4 m-1 lg:w-7 lg:h-7 text-white' />
        </div>
      </div>
    </div>
  </div>
);

// Instagram Feed Preview Component
const InstagramFeedPreview = ({ post }) => (
  <div className='max-w-[400px] flex items-center justify-center'>
    <div className='bg-white rounded-lg overflow-hidden shadow-lg border border-gray-200'>
      {/* Header */}
      <div className='flex items-center justify-between p-2 lg:p-3 border-b border-gray-200'>
        <div className='flex items-center gap-1.5 lg:gap-2'>
          <div className='w-6 h-6 lg:w-8 lg:h-8 rounded-full bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600 p-[2px]'>
            <div className='w-full h-full rounded-full bg-white flex items-center justify-center'>
              <span className='text-gray-800 text-[10px] lg:text-xs font-semibold'>B</span>
            </div>
          </div>
          <span className='text-xs lg:text-sm font-semibold'>yourbusiness</span>
        </div>
        <button className='text-base lg:text-xl font-bold'>⋯</button>
      </div>

      {/* Image */}
      <div className='w-full bg-gray-100'>
        <img
          src={post.path || post.imageUrl}
          alt='Feed Preview'
          className='w-full h-auto object-cover'
        />
      </div>

      {/* Actions */}
      <div className='p-2 lg:p-3'>
        <div className='flex items-center justify-between mb-1 lg:mb-2'>
          <div className='flex items-center gap-2 lg:gap-4'>
            <Heart className='w-4 h-4 lg:w-6 lg:h-6' />
            <MessageCircle className='w-4 h-4 lg:w-6 lg:h-6' />
            <Send className='w-4 h-4 lg:w-6 lg:h-6' />
          </div>
          <Bookmark className='w-4 h-4 lg:w-5 lg:h-5' />
        </div>

        {/* Likes */}
        <div className='text-[10px] lg:text-sm font-semibold mb-0.5 lg:mb-1'>89 likes</div>

        {/* Caption */}
        {post.caption && (
          <div className='text-[10px] lg:text-sm'>
            <span className='font-semibold mr-1'>yourbusiness</span>
            <span className='text-gray-800'>{post.caption}</span>
          </div>
        )}
      </div>
    </div>
  </div>
);

export default InstagramPreview;
